<template>
  <div>
    <label><slot name="label"></slot></label>
    <CheckboxGroupRoot v-model="model" class="flex flex-col gap-0.5">
      <!-- class="flex  cursor-pointer" -->
      <CheckboxRoot
        v-for="item in items"
        :key="item.value"
        :value="item.value"
        :class="[
          'items-center gap-3 p-4 border border-neutral-700 flex appearance-none rounded-md',
          `data-[state='checked']:bg-neutral-800 dark:data-[state='checked']:bg-white`,
          isExistingSport(item.value) ? 'opacity-50' : '',
        ]"
        :disabled="isExistingSport(item.value)"
        @before-update:modelValue="preventUnchecking($event, item.value)"
      >
        <div
          class="h-[1.2rem] w-[1.2rem] rounded flex items-center justify-center border"
          :class="[
            `[[data-state='checked']_&]:border-cardinal-800 [[data-state='checked']_&]:bg-cardinal-500 dark:[[data-state='checked']_&]:bg-cardinal`,
            `[[data-state='checked'][data-disabled]_&]:border-neutral-400 [[data-state='checked'][data-disabled]_&]:bg-neutral-400 dark:[[data-state='checked'][data-disabled]_&]:bg-neutral-200`,
            `[[data-state='unchecked']_&]:border-neutral-400 [[data-state='unchecked']_&]:bg-neutral-200 dark:[[data-state='unchecked']_&]:bg-white`,
          ]"
        >
          <CheckboxIndicator class="">
            <i
              class="fas fa-check text-white [[data-state='checked'][data-disabled]_&]:text-neutral-900 dark:[[data-state='checked'][data-disabled]_&]:text-neutral-700"
              :class="[]"
            ></i>
          </CheckboxIndicator>
        </div>
        <label class="flex flex-row gap-4 items-center">
          <span
            class="select-none"
            :class="[
              `[[data-state='checked']_&]:text-white dark:[[data-state='checked']_&]:text-black`,
              `[[data-state='unchecked']_&]:text-black dark:[[data-state='unchecked']_&]:text-white`,
            ]"
          >
            <span class="font-bold">{{ item.label }}</span> (D1, D2, D3)
            <span
              v-if="isExistingSport(item.value)"
              class="text-neutral-200 dark:text-neutral-800 ml-2 text-sm"
            >
              (Already Subscribed)
            </span>
          </span>
        </label>
      </CheckboxRoot>
      <div></div>
    </CheckboxGroupRoot>
  </div>
</template>

<script setup lang="ts">
import { CheckboxGroupRoot, CheckboxIndicator, CheckboxRoot } from 'reka-ui';
import { onMounted, watch } from 'vue';

// Define props for customizing the items if needed
const props = defineProps<{
  items?: { label: string; value: Sport }[];
  existingSports?: Sport[]; // New prop to hold already subscribed sports
}>();

// Use defineModel instead of local ref
const model = defineModel<Sport[]>({ default: [] });

// Default items if not provided via props
const defaultItems: Array<{ label: string; value: Sport }> = [
  { label: 'Baseball', value: 'Baseball' },
  { label: 'Softball', value: 'Softball' },
];

// Use provided items or default items
const items = props.items || defaultItems;

// Check if a sport is in the existingSports array
const isExistingSport = (sportValue: Sport) => {
  return props.existingSports?.includes(sportValue) || false;
};

// Ensure existing sports are always included in the model
onMounted(() => {
  if (props.existingSports && props.existingSports.length > 0) {
    // Make sure all existing sports are in the model
    const newModel = [...model.value];
    let changed = false;

    props.existingSports.forEach((sport) => {
      if (!newModel.includes(sport)) {
        newModel.push(sport);
        changed = true;
      }
    });

    if (changed) {
      model.value = newModel;
    }
  }
});

// Watch for changes to prevent unchecking existing sports
watch(
  () => model.value,
  (newValue) => {
    if (props.existingSports && props.existingSports.length > 0) {
      // If any existing sport is not in the model, add it back
      const missingExistingSports = props.existingSports.filter(
        (sport) => !newValue.includes(sport)
      );

      if (missingExistingSports.length > 0) {
        model.value = [...newValue, ...missingExistingSports];
      }
    }
  },
  { deep: true }
);

// Prevent unchecking of existing sports
const preventUnchecking = (event: Event, value: Sport) => {
  if (isExistingSport(value)) {
    event.preventDefault();
  }
};
</script>
